import { ComponentType } from "react";
import LandingDynamic from "../LandingDynamic";
import { ChatLayout } from "../LandingSapphicChat";
import { DocLayout } from "../LandingDocument";
import LandingReservation, { RESERVATION_EXAMPLE } from "./LandingReservation";
import LandingReceipt, { RECEIPT_EXAMPLE } from "./LandingReceipt";
import LandingSapphicChat from "../LandingSapphicChat";
import { DocCeaseDesist } from "../LandingDocument";

/**
 * Landing template registry.
 *
 * A landing variant (landing_variants.config, created via the ops MCP) picks
 * its layout with `config.template`; omitted/unknown templates fall back to
 * the classic LandingDynamic. Adding a template = one component + one entry
 * here + one deploy; after that, every variant of it ships via MCP with no
 * deploy. See docs/landing-templates.md for each template's config schema.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const LANDING_TEMPLATES: Record<string, ComponentType<{ config: any }>> = {
  chat: ChatLayout,
  document: DocLayout,
  reservation: LandingReservation,
  receipt: LandingReceipt,
};

export function TemplatePage({ config, language }: { config: any; language?: string }) {
  const Template = config?.template ? LANDING_TEMPLATES[config.template] : undefined;
  if (Template) return <Template config={config} />;
  return <LandingDynamic config={config} language={language ?? "en"} />;
}

/** /tpl/:template — live previews of each template's example config (QA aid). */
export const TEMPLATE_PREVIEWS: Record<string, ComponentType> = {
  chat: LandingSapphicChat,
  document: DocCeaseDesist,
  reservation: () => <LandingReservation config={RESERVATION_EXAMPLE} />,
  receipt: () => <LandingReceipt config={RECEIPT_EXAMPLE} />,
};
